<template>
  <ProfileForm />
</template>

<script setup lang="ts">
import ProfileForm from "@/components/forms/ProfileForm.vue";
</script>
